import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonService } from '../../common.service';

@Component({
  selector: 'app-terms',
  imports: [RouterLink],
  templateUrl: './terms.html',
  styleUrl: './terms.scss',
})
export class Terms implements OnInit {
  private readonly commonService = inject(CommonService);

  ngOnInit(): void {
    this.commonService.showTitle('/assets/titles/terms.jpg');
  }
}
